export enum PurchaseOrderStatus {
  Draft = "DRAFT",
  SupplierContacted = "SUPPLIER_CONTACTED",
  Ordered = "ORDERED",
  PartiallyReceived = "PARTIALLY_RECEIVED",
  Closed = "CLOSED",
  Cancelled = "CANCELLED",
}
